import {Placeholder, Tag, Text} from '@/components-v2/atoms'
import {ImagePreview} from '@/components-v2/molecules'
import {Card} from '@/components-v2/organisms'

/**
 * @param {{
 *   bannerUrl?: string,
 *   promotionTitle?: string,
 *   promotionDescription?: string,
 *   promotionExcerpt?: string,
 *   expiryDate?: string,
 * }} props
 */
export const PromotionAppPreview = ({bannerUrl, promotionTitle, promotionDescription, promotionExcerpt, expiryDate}) => {
  // Read the calendar date directly to avoid timezone shifts in the expiry label.
  const expiryLabel = expiryDate ? `Until ${expiryDate}` : 'Until DD/MM/YYYY'

  return (
    <div className="flex w-full justify-center">
      <Card
        state="non-interactive"
        type="basic"
        viewport="mobile"
        className="!w-full !max-w-[320px] !rounded-none !p-0"
        style={{
          '--color-background-utility-low-contrast': '#ffffff',
          '--color-text-primary': '#191c1c',
          '--color-border-default': '#d7dadd',
          backgroundColor: '#ffffff',
          color: '#191c1c',
        }}
        cardHeader={{hideHeader: true}}
        cardBody={{
          type: 'slot',
          slot: (
            <div className="w-full">
              <div className="relative aspect-video w-full overflow-hidden">
                {bannerUrl ? (
                  <ImagePreview
                    src={bannerUrl}
                    aria-label="Promotion banner"
                    width="100%"
                    height="100%"
                    className="promotion-app-preview-image"
                    showRotateControls={false}
                    showFlipControl={false}
                    showDownloadControl={false}
                    showPrintControl={false}
                    showZoomControls={false}
                  />
                ) : (
                  <Placeholder ratio="16:9" className="!h-full w-full" aria-label="No promotion image" />
                )}
              </div>

              <div className="flex flex-col gap-2 p-4">
                <div className="flex flex-row gap-2">
                {promotionExcerpt && (
                  <Tag
                  text={promotionExcerpt ?? 'Excerpt'}
                  type="outlined"
                  color="red"
                  size="large"
                  isCopyable={false}
                  className="self-start"
                  style={{backgroundColor: '#D3351C', color: '#ffffff', borderRadius: '4px'}}
                />
                )}
                <Tag
                  text={expiryLabel}
                  type="outlined"
                  color="default"
                  size="large"
                  isCopyable={false}
                  className="self-start"
                  style={{backgroundColor: '#ffffff', color: '#191c1c', border: '1px solid #747e86', borderRadius: '4px'}}
                />
                </div>
                <div className="flex flex-col gap-2" aria-live="polite" aria-atomic="true">
                  <Text headingLevel={5} className="break-words">
                    {promotionTitle && promotionTitle !== '' ? promotionTitle : 'Promotion Name'}
                  </Text>
                  <Text size="xsmall" style={{color: '#5f686f'}}>
                    {promotionDescription && promotionDescription !== '' ? promotionDescription : 'A line of more details about the direct offer. A line of more details about the direct offer here.'}
                  </Text>
                </div>
              </div>
            </div>
          ),
        }}
      />
    </div>
  )
}